import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

// This is also a Suspense fallback: translation loading must never suspend it.
const SuspenseLoadingIndicator = () => {
  const { tCommon, i18n, ready } = useCustomTranslation({
    namespaces: ['common'],
    useSuspense: false
  });
  const label =
    ready && i18n.exists('application_loading', { ns: 'common' })
      ? tCommon('application_loading')
      : '';

  return (
    <div className="AppLoadingIndicator" role="status" aria-live="polite">
      <span className="AppLoadingIndicator_spinner" aria-hidden="true" />
      <span className="AppLoadingIndicator_label">{label}</span>
    </div>
  );
};
export default SuspenseLoadingIndicator;
